import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class AlertasService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private tokenService: TokenService, private http: HttpClient) { }

  atualizaAlertaPorCliente(cliente_id, alerta): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/configuracao-alerta/cliente/${cliente_id}`, alerta, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizaAlertaPorDispositivo(dispositivo_id, alerta): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/configuracao-alerta/dispositivo/${dispositivo_id}`, alerta, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken()}),
      params: {}
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  getContadorAlertas(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/Alerta/getCount`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getListagemAlertas(params, filters?): Observable<any> {
    this.httpOptions.params = params;
    if(filters) {
      this.httpOptions.params = {...params, ...filters};
    }
    return this.http.get(`${this.apiUrl}api/Alerta/listNotificacaoTodos`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getAlertasByEmpresa(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/configuracao-alerta/empresa`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizaAlertaPorEmpresa(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/configuracao-alerta/empresa`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getConfigUserAlerts(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/alertas/tipo/configUser/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  updateConfigUserAlerts(id, payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/alertas/tipo/configUser/${id}`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  marcarAlertaComoLido(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/Alerta/marcar-lido`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  //------- AUTOMAÇÃO DE ALERTAS -------//
  getDropdownTiposAlertas(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/gatilho-alertas/dropdown-tipo-gatilho-alerta`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getDropdownOperadoresAlertas(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/gatilho-alertas/dropdown-operadores`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getDropdownCondicoesAlertas(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/gatilho-alertas/dropdown-condicoes`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getInformacoesCampoAlertas(chave): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/gatilho-alertas/obter-informacoes/${chave}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getListagemAlertasAutomaticos(filtros, params): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(
      `${this.apiUrl}api/gatilho-alertas/listagem`, 
      filtros, 
      this.httpOptions
    )
      .pipe(
        catchError(this.handleError)
      );
  }

  excluirGatilhoAlertas(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.delete(`${this.apiUrl}api/gatilho-alertas/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  playGatilhoAlertas(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/gatilho-alertas/iniciar/${id}`, '', this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  pauseGatilhoAlertas(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/gatilho-alertas/pausar/${id}`, '', this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  criarNovoGatilhoAlertas(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/gatilho-alertas`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  editarNovoGatilhoAlertas(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/gatilho-alertas`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  obterGatilhoAlerta(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/gatilho-alertas/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  buscarAvisos(token): Observable<any> {
    return this.http.get(`${this.apiUrl}api/notificacao-sistema/avisos`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
